import { render, staticRenderFns } from "./StudentReferral.vue?vue&type=template&id=125da4da&scoped=true&"
import script from "./StudentReferral.vue?vue&type=script&lang=js&"
export * from "./StudentReferral.vue?vue&type=script&lang=js&"
import style0 from "./StudentReferral.vue?vue&type=style&index=0&id=125da4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125da4da",
  null
  
)

export default component.exports